// extracted by css-extract-rspack-plugin
export default {"tooltipIcon":"ConstructorProvider_tooltipIcon__MerZ_"};